export function setMin (number, min) {
  return Math.max(number, min)
}

export function setMax (number, max) {
  return Math.min(number, max)
}

export function setMinMax (number, min, max) {
  return setMax(setMin(number, min), max)
}
